import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { VehicleModel }   from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-transaction',
  template: require('./vehicle.transaction.component.html')
})
export class VehicleTransactionComponent {
  @Input() vehicle: VehicleModel = {} as VehicleModel;

  @Output() onDelete: EventEmitter<void> = new EventEmitter();
  @Output() onPrint : EventEmitter<void> = new EventEmitter();

  collapsed = false;

  constructor (
    public companyService: CompanyService
  ) {}

  canPrint () : boolean {
    return this.companyService.country('australia')
      && this.companyService.isState('NSW')
      && this.companyService.hasDealership()
      && !!this.vehicle.sale_status;
  }
}
